import { Component, Input } from '@angular/core';
import { ReviewIdEnum } from '@inshared/shared/core';
import { InsocialBtnService } from './insocial-btn.service';

@Component({
    selector: 'ins-insocial-btn',
    templateUrl: 'insocial-btn.component.html',
})
export class InsocialBtnComponent {
    @Input() source: string | null = null;
    @Input() sId: number = ReviewIdEnum.CarInsurance;
    @Input() title: string = '';

    constructor(private insocialBtnService: InsocialBtnService) {}

    public get url(): string {
        return this.insocialBtnService.createUrl(this.sId, this.source);
    }
}
